import { KYMW0600Component } from './kymw0600.component';
import { RelatedInfoModel } from './vo/related-info.model';
import * as wjcCore from '@grapecity/wijmo';
import { TargetGoodsInfoModel } from './vo/target_goods-info.model';
/**
 * 関連商品設定画面の値を管理するクラス
 *
 * @export KYMW0600Model
 * @class KYMW0600Model
 */
export class KYMW0600Model {

  kymw0600Component: KYMW0600Component;

  /**
   * 関連商品一覧
   */
  public relatedGoodsList: Array<any> = new Array<any>();

  /**
   * 候補一覧
   */
  public targetGoodsList: Array<any> = new Array<any>();

  // 更新ボタン活性制御
  public enabledUpdate: boolean = <boolean>true;

  /**
   * サーバからの受信データにて関連商品情報を更新する
   *
   * @param serverData サーバからの受信データ
   *
   */
  public updateRelatedInfo(serverData: any, targetPcode: string): void {
    if (serverData) {
      const tempList = new Array<any>();
      // serverDataタグの中に入っているデータが、複数存在しないか確認
      if (serverData.constructor === Array) {
        // serverDataタグの中に入っているデータ分処理を行う
        for (let i = Number(0); i < serverData.length; i++) {
          // 関連商品設定VOを生成し、Listに追加する
          tempList.push(this.createRelatedInfoModel(serverData[i]));
        }
      } else {
        // 関連商品設定VOを生成し、Listに追加する
        tempList.push(this.createRelatedInfoModel(serverData));
      }
      // 順番入替
      const formatList = [];
      // 遷移元画面から送られた商品情報
      let targetElement = new RelatedInfoModel();
      tempList.forEach(element => {
        if (targetPcode == element.pCode) {
          targetElement = element;
        }
      });
      // 1行目に新Pコード
      let elementNew = null;
      for (const e of tempList) {
        if (targetElement.relationPcodeNew == e.pCode) {
          elementNew = e;
        }
      }
      if (!elementNew) {
        elementNew = new RelatedInfoModel();
      }
      elementNew.oldNew = "新";
      formatList.push(elementNew);

      // 2行目に遷移元のPコード
      formatList.push(targetElement);

      // 3行目に旧Pコード
      let elementOld = null;
      for (const e of tempList) {
        if (targetElement.relationPcodeOld == e.pCode) {
          elementOld = e;
        }
      }
      if (!elementOld) {
        elementOld = new RelatedInfoModel();
      }
      elementOld.oldNew = "旧";
      formatList.push(elementOld);

      this.relatedGoodsList = this.relatedGoodsList.concat(formatList);
      setTimeout(() => {
        this.kymw0600Component.dg_relatedInfo.collectionView.sortDescriptions.clear();
        const sortDirection = this.kymw0600Component.dg_relatedInfo.collectionView.sortDescriptions.map(function (sortDesc) {
          return { property: sortDesc.property, ascending: sortDesc.ascending };
        });
        for (let i = 0; i < sortDirection.length; i++) {
          const sortDesc = sortDirection[i];
          this.kymw0600Component.dg_relatedInfo.collectionView.sortDescriptions.push(
            new wjcCore.SortDescription(sortDesc.property, sortDesc.ascending)
          );
        }
      });
    }
  }

  /**
   * 関連商品情報VOを生成し、返す
   * @param goodsGroup 関連商品情報のXML情報が入ったObject
   * @return 関連商品情報VO
   *
   */
  public createRelatedInfoModel(goodsGroup: any): RelatedInfoModel {
    // VOの生成
    const tempVO: RelatedInfoModel = new RelatedInfoModel();
    tempVO.pCode = goodsGroup.PCode; // Pコード
    tempVO.goodsName = goodsGroup.GuideGoodsName; // 商品名
    tempVO.guideStandardName = goodsGroup.GuideStandardName; // 規格名
    tempVO.makerName = goodsGroup.MakerName; // メーカー名
    tempVO.payeeClientCode = goodsGroup.PayeeClientCode; // 支払先取引先コード
    tempVO.supplierNameKanji = goodsGroup.SupplierNameKanji; // 取引先名称(漢字)
    tempVO.displaySupplier = 
      goodsGroup.PayeeClientCode + ": " + goodsGroup.SupplierNameKanji; // 表示用取引先
    tempVO.regularRegistDate = goodsGroup.RegularRegistDate; // 本登録日時
    tempVO.relationPcodeOld = goodsGroup.RelationPCodeOld; // 関連Pコード(旧)
    tempVO.relationPcodeNew = goodsGroup.RelationPCodeNew; // 関連Pコード(新)
    tempVO.applyTermEnd = goodsGroup.ApplyTermEnd; // 取扱期間（終了）
    tempVO.groupId = goodsGroup.GroupId; // グループID

    // GroupIdタグにデータが存在せず、GroupIdが0より大きい(マイナスでない)場合に設定する
    if (goodsGroup.GroupId != null && goodsGroup.GroupId > 0) {
      tempVO.groupId = goodsGroup.GroupId;
    }

    return tempVO;
  }

  /**
   * 候補一覧を設定する
   * 
   * @param serverData サーバからの受信データ
   */
  public updateTargetGoodsInfo(serverData: any): void {
    if (serverData != null) {
      // VOの生成
      const tempList = [];
      serverData.forEach(element => {
        const tempVO: TargetGoodsInfoModel = new TargetGoodsInfoModel();
        tempVO.pCode = element.PCode; // Pコード
        tempVO.goodsName = element.GuideGoodsName; // 商品名
        tempVO.guideStandardName = element.GuideStandardName; // 規格名
        tempVO.makerName = element.MakerName; // メーカー名
        tempVO.payeeClientCode = element.PayeeClientCode; // 支払先取引先コード
        tempVO.supplierNameKanji = element.SupplierNameKanji; // 取引先名称(漢字)
        tempVO.displaySupplier = 
          element.PayeeClientCode + ": " + element.SupplierNameKanji; // 表示用取引先
        tempVO.regularRegistDate = element.RegularRegistDate; // 本登録日時
        tempVO.relationPcodeOld = element.RelationPCodeOld; // 関連Pコード(旧)
        tempVO.relationPcodeNew = element.RelationPCodeNew; // 関連Pコード(新)
        tempVO.groupId = element.GroupId; // グループID
        tempVO.applyTermEnd = element.ApplyTermEnd; // 取扱期間（終了）

        tempList.push(tempVO);
      });

      this.targetGoodsList = tempList;
    }
  }
}
